import { Form } from '@fulcrumapp/fulcrum-core';
import { FormSchema } from '@fulcrumapp/query-sql';
import { useQuery } from '@tanstack/react-query';
import { formsApiClient } from '../services/fetch/forms-api-client';
import type { QueryColumnResponse, RestApiForm } from '../tasks/types';
import { loadColumns } from './use-form-app';
import { useApp } from './use-app';

export interface SystemAppData {
  /** @deprecated use restForm instead */
  rawForm?: RestApiForm
  restForm: RestApiForm
  queryColumns: QueryColumnResponse
  /** @deprecated build your own from restForm and Query columns. @see sqlBuilder */
  systemApp?: Form
  /** @deprecated build your own from restForm and Query columns. @see sqlBuilder */
  systemAppSchema: FormSchema
}

export default function useSystemApp(resourceId: string) {
  const app = useApp();
  const apiClient = formsApiClient(app.api.token);

  const loadFormData = async () => {
    // We need to get the SystemApp via rest, and the schema from query,
    // both of which are needed to get records from query
    const { form: rawForm } = await apiClient.fetchSystemApp(resourceId);
    const rawColumns = await loadColumns(app.dataSource, resourceId);
    const systemApp = new Form(rawForm); // Deprecated

    const loadedData: SystemAppData = {
      rawForm, // Deprecated
      restForm: rawForm,
      queryColumns: rawColumns,
      systemApp, // Deprecated
      systemAppSchema: new FormSchema( // Deprecated
        systemApp,
        rawColumns.form,
        rawColumns.repeatables,
        { fullSchema: true },
      ),
    };
    return loadedData;
  };

  return useQuery(['system_app_data', resourceId], loadFormData,
    {
      refetchOnWindowFocus: false,
    });
}
